// Which poses the multi-pose builder should show.
//
// `favoriteIds` is OVERLOADED across Builder's callers, so filtering cannot be inferred
// from it being non-empty:
//   - the favorites PICKER passes the customer's chosen poses and wants ONLY those shown;
//   - MultiPoseEdit passes the poses already in the order, purely to badge them with a
//     heart while the customer swaps among ALL their poses;
//   - the senior flow passes the single yearbook pose, purely to sort it first, while the
//     senior still builds from the WHOLE session.
// Filtering on a non-empty favoriteIds broke the latter two (they lost every other pose).
//
// So filtering is gated on an explicit `restrictToFavorites` flag that ONLY the picker
// flow (MultiPosePackageBuilder, which carries URL `favorites=`) sets. Every other caller
// gets the old behavior: favorites merely sorted to the front, full set intact.
//
// Even for the picker, two cases keep the full set:
//   - a buy-all / digital-images-only option delivers EVERY photo by definition;
//   - a favorite set that matches nothing (stale ids) would filter to empty, so fall back
//     to all poses rather than show an empty builder.
//
// favoriteIds are strings (from the URL); pose.id is a Spraypaint string id.
export default function visiblePoses(poses, favoriteIds, option, restrictToFavorites = false) {
  const all = poses || [];
  const ids = favoriteIds || [];

  const favorited = all.filter((pose) => ids.includes(pose.id));
  const shouldFilter = restrictToFavorites && favorited.length > 0 && !option?.digitalImagesOnly;
  const base = shouldFilter ? favorited : all;

  // Favorites-first ordering, kept for the highlight/sort and buy-all/fallback cases (a
  // no-op once already filtered to favorites). Copy first — Array#sort mutates, and
  // `base` may be the caller's poses array.
  return [...base].sort(
    (a, b) => ids.includes(b.id) - ids.includes(a.id),
  );
}
